<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">画像一覧</li>
            </ol>
        </nav>
        <div class="container">
            <div class="d-flex justify-content-end">
                <button class="btn btn-outline-primary" @click="showUploader()">
                    <i class="fas fa-upload"></i>
                    画像アップロード
                </button>
            </div>
        </div>
        <div class="sticky">
            <page :last_page="pictures.last_page" v-model="page" @goto="goto"></page>
        </div>
        <div class="container picture-list">
            <ul class="nav">
                <li class="nav-item">
                    <router-link to="/admin/pictures/all" class="nav-link" :class="{active: $route.params.categ == 'all'}">
                        すべて
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/admin/pictures/background" class="nav-link" :class="{active: $route.params.categ == 'background'}">
                        <i class="far fa-image"></i>
                        背景
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/admin/pictures/portal" class="nav-link" :class="{active: $route.params.categ == 'portal'}">
                        <i class="fas fa-home"></i>
                        ポータル
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/admin/pictures/novel" class="nav-link" :class="{active: $route.params.categ == 'novel'}">
                        <i class="fas fa-book"></i>
                        小説表紙
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/admin/pictures/banner" class="nav-link" :class="{active: $route.params.categ == 'banner'}">
                        <i class="far fa-flag"></i>
                        バナー
                    </router-link>
                </li>
            </ul>
            <div class="d-flex justify-content-center flex-wrap">
                <div class="card bg-card m-2" v-for="v in pictures.data" :key="v.id">
                    <div class="img-column">
                        <img :src="v.thumb_url" class="mx-auto d-block cover" />
                    </div>
                    <button type="button" class="btn btn-link text-danger btn-remove" @click="remove(v)">
                        <i class="fas fa-times"></i>
                    </button>
                    <div class="card-footer">
                        <div class="small text-muted">
                            {{$filters.getByte(v.size)}}
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fas fa-edit pointer text-primary" @click="showUploader(v.id)"></i>
                            </div>
                            <div>
                                <i class="far fa-image" data-toggle="tooltip" title="背景" v-if="v.for_background"></i>
                                <i class="fas fa-home" data-toggle="tooltip" title="ポータル" v-if="v.for_portal"></i>
                                <i class="fas fa-book" data-toggle="tooltip" title="小説表紙" v-if="v.for_novel"></i>
                                <i class="far fa-flag" data-toggle="tooltip" title="バナー" v-if="v.for_banner"></i>
                            </div>
                        </div>
                        <div class="small" v-if="v.license">
                            <span v-html="v.license"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nothing" v-if="pictures.total == 0">
            <h4>画像はありません。</h4>
            <p class="small">現在のユーザー権限を確認してください。<br>管理者以外のデータを参照することはできません。</p>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
        <picture-uploader
            :picture_id="picture_id"
            @load="load()"></picture-uploader>
    </div>
</template>

<style scoped lang="scss">
.picture-list {
    max-width: 960px;
}
.bg-card {
    width: 213px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    .img-column {
        background-color: black;
        position: relative;
        height: 300px;
        .cover {
            object-fit: cover;
            width: 213px;
            height: 300px;
        }
    }
    .btn-remove {
        position: absolute;
        top: 2px;
        right: 2px;
        font-size: 2rem;
        line-height: 1;
        padding: 0;
        &:hover {
            opacity: .8;
        }
    }
}
</style>

<script>
import page from "components/Page";
import pictureUploader from "./pictureUploader.vue";
export default {
    components: {
        page,
        pictureUploader,
    },
    data() {
        return {
            pictures: {},
            page: 1,
            file: {
                license: "",
            },
            picture_id: null,
            categ: null,
            isLoading: false,
        }
    },
    methods: {
        goto(n) {
            this.page = n;
            this.$nextTick(() => {this.load()});
        },
        load() {
            this.isLoading = true;
            axios.get("/admin/pictures/get", {params: {
                page: this.page,
                categ: this.$route.params.categ !== "all" ? this.$route.params.categ : null,
            }}).then(res => {
                this.pictures = res.data;
                this.isLoading = false;
                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 400);
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        remove(v) {
            Swal.fire({
                title: "削除",
                text: "画像を削除します。よろしいですか？",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/admin/picture/remove", {id: v.id}).then(res => {
                        alert.msg("画像を削除しました");
                        this.load();
                    }).catch(err => { alert.err(err.response); });
                }
            });
        },
        showUploader(id = null) {
            this.picture_id = id;
            this.$nextTick(() => {
                $("#picture-uploader").modal();
            });
        },
    },
    watch: {
        '$route'(n, o) {
            if (n.path.match(/^\/admin\/pictures/)) {
                this.page = 1;
                this.load();
            }
        }
    },
    mounted() {
        this.load();
    }
}
</script>